export default {
    ACCOUNT_TYPE_PRIVATE: {
        title: 'Privatkonto',
        value: 0
    },
    ACCOUNT_TYPE_BUSINESS: {
        title: 'Geschäftskonto',
        value: 1
    },
    toArray()
    {
        return [
            this.ACCOUNT_TYPE_PRIVATE,
            this.ACCOUNT_TYPE_BUSINESS
        ]
    }
}